import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; 
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
  Button,
} from '@mui/material';
import moment from 'moment';
import Footer from '../navbar/Footer';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(LinearScale, PointElement, LineElement, Tooltip, Legend);

const icclbData = [
    {
    "title": "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) – Février 2026",
    "link": "/documents/ICCLB/ICC_fevr_2026.pdf",
    "image": "assets/indicesICCLB/icclb2025_1m.PNG",
    "description": "En février 2026, le coût des matériaux de construction des logements neufs à Bujumbura a enregistré une augmentation de 0,9 % par rapport au mois de janvier 2026.",
    "date": "2026-02-12",
    "publicationDate": "2026-02-11"
  },
    {
    "title": "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) – Janvier 2026",
    "link": "/documents/ICCLB/ICC_janv_2026.pdf",
     "image": "assets/indicesICCLB/icclb2025_1m.PNG",
    "description": "Le coût des matériaux de construction des logements neufs à Bujumbura a connu une hausse de 2,2% en janvier 2026 par rapport à décembre 2025.",
    "date": "2026-01-12",
    "publicationDate": "2026-01-11"
  },
   {
    "title": "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) – Décembre 2025",
    "link": "/documents/ICCLB/ICC_dec_2025.pdf",
    "image": "assets/indicesICCLB/icclb2025_1m.PNG",
    "description": "Le coût des matériaux de construction des logements neufs à Bujumbura a connu une baisse de 1,3% en décembre 2025 par rapport à novembre 2025, principalement en raison de la baisse des prix des matériaux de construction (-1,7 %) ",
    "date": "2025-12-09",
    "publicationDate": "2026-01-11"
  },
   {
    "title": "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) – Novembre   2025",
    "link": "/documents/ICCLB/ICC_nov_2025.pdf",
    "image": "assets/indicesICCLB/icclb2025_1m.PNG",
    "description": "Le coût des matériaux de construction des logements neufs à Bujumbura a connu une hausse de 1,0% en novembre 2025 par rapport à octobre 2025, principalement en raison de la hausse des prix de la main-d'œuvre (+4,1 %). ",
    "date": "2025-12-09",
    "publicationDate": "2025-12-11"
  },
   {
    "title": "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) – Octobre   2025",
    "link": "/documents/ICCLB/ICC_octobre_2025.pdf",
    "image": "assets/indicesICCLB/icclb2025_1m.PNG",
    "description": "Le coût des matériaux de construction des logements neufs à Bujumbura a connu une hausse de 0,8 % en octobre 2025 par rapport à septembre 2025. ",
    "date": "2025-10-28",
    "publicationDate": "2025-11-08"
  },
    {
    "title": "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) – Septembre  2025",
    "link": "/documents/ICCLB/ICC_sept_2025.pdf",
    "image": "assets/indicesICCLB/icclb2025_1m.PNG",
    "description": "Le coût des matériaux de construction des logements neufs à Bujumbura a connu une hausse de 1,5 % en septembre 2025 par rapport à août 2025.",
    "date": "2025-09-28",
    "publicationDate": "2025-10-08"
  },
   {
    "title": "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) – Août  2025",
    "link": "/documents/ICCLB/ICC_Aout_2025.pdf",
    "image": "assets/indicesICCLB/icclb2025_1m.PNG",
    "description": "Le coût des matériaux de construction des logements neufs à Bujumbura a connu une hausse de 2,9 % en août 2025 par rapport à juillet 2025.",
    "date": "2025-08-28",
    "publicationDate": "2025-09-08"
  },
     {
    "title": "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) – juillet 2025",
    "link": "/documents/ICCLB/ICC_juil_2025.pdf",
    "image": "assets/indicesICCLB/icclb2025_1m.PNG",
    "description": "Une hausse de 0,3% pour le mois de juillet 2025 par rapport au mois de juin 2025, principalement attribué à la hausse des prix des matériaux de construction de   0,4 %.",
    "date": "2025-07-28",
    "publicationDate": "2025-08-08"
  },
    {
    "title": "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) – juin 2025",
    "link": "/documents/ICCLB/ICC-juin-2025.pdf",
    "image": "assets/indicesICCLB/icclb2025_1m.PNG",
    "description": "Une hausse de 1,4 % pour le mois de juin 2025 par rapport au mois de mai 2025, principalement attribué à la hausse des prix des matériaux de construction de  1,9 % et de la main d’œuvre de 15,3 %.",
    "date": "2025-06-28",
    "publicationDate": "2025-07-09"
  },
    {
    "title": "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) – mai 2025",
    "link": "/documents/ICCLB/ICCmai2025.pdf",
    "image": "assets/indicesICCLB/icclb2025_1m.PNG",
    "description": "Une hausse de 4,4% pour le mois de mai 2025 par rapport au mois d’avril 2025, principalement attribué à la hausse des prix des matériaux de construction de 1,9% et de la main d’œuvre de 15,8%.",
    "date": "2025-05-28",
    "publicationDate": "2025-06-09"
  },
    {
    "title": "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) – Avril 2025",
    "link": "/documents/ICCLB/ICCLBavril2025.pdf",
    "image": "assets/indicesICCLB/icclb2025_1m.PNG",
    "description": "Une hausse de 1,7% pour le mois d’avril 2025 par rapport au mois de mars 2025, principalement attribué à la hausse des prix des matériaux de construction de 2,2% et de la location du matériel de 1,4%.",
    "date": "2025-04-28",
    "publicationDate": "2025-05-09"
  },
  {
    "title": "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) – Mars 2025",
    "link": "/documents/ICCLB/ICCmars2025.pdf",
    "image": "assets/indicesICCLB/icclb2025_1m.PNG",
    "description": "Une hausse de 1,2% pour le mois de mars 2025 par rapport au mois de février 2025, principalement attribué à la hausse des prix des matériaux de construction de 1,2% et de la location du matériel de 4,1%.",
    "date": "2025-04-28",
    "publicationDate": "2025-05-08"
  }
,  
  {
    "title": "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) – Février 2025",
    "link": "/documents/ICCLB/ICC-fevrier-2025.pdf",
    "image": "assets/indicesICCLB/icclb2025_1m.PNG",
    "description": "Une hausse de 3,0% pour le mois de février 2025 par rapport au mois de janvier 2025, principalement attribué à la hausse des prix de la main d’œuvre de 14,1%, des matériaux de construction de 0,6% de la location du matériel de 1,5%.",
    "date": "2025-02-28",
    "publicationDate": "2025-03-07"
  }
,  
  {
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de janvier 2025",
    link: "/documents/ICCLB/ICC-janv-2025.pdf",
    image: 'assets/indicesICCLB/icclb2025_1m.PNG',
    description: "Une hausse de 0,7 % pour le mois de janvier 2025 par rapport au mois précédent, principalement attribué à la hausse des prix des matériaux de construction (+0,8 %) et à l'augmentation des coûts de location du matériel (+1,9 %).",
    date: "2025-01-28",
    publicationDate: "2025-02-07"
},
{
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de décembre 2024",
    link: "/documents/ICCLB/ICC-dec-2024.pdf",
    image: 'assets/indicesICCLB/icclb2024_12m.PNG',
    description: " Une hausse de 2,1 % pour le mois de décembre 2024 par rapport à novembre 2024, dû à une augmentation des prix des matériaux (+1,7 %) et d'une forte hausse des coûts de location du matériel (+15,6 %).",
    date: "2024-12-28",
    publicationDate: "2025-01-09"
},
{
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois d'octobre 2024",
    link: "/documents/ICCLB/ICC-oct-2024.pdf",
    image: 'assets/indicesICCLB/icclb2024_10m.PNG',
    description: "Une hausse de 2,6 % pour le mois d'octobre 2024 par rapport à septembre 2024, en raison de l'augmentation des prix des matériaux (+3,1 %) et d'une hausse de 4,8 % des coûts de location du matériel.",
    date: "2024-10-28",
    publicationDate: "2024-11-08"
},
{
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de septembre 2024",
    link: "/documents/ICCLB/ICC-sept-2024.pdf",
    image: 'assets/indicesICCLB/icclb2024_10m.PNG',
    description: "Une hausse significative de 6,3 % pour le mois septembre 2024 des coûts des matériaux de construction des logements neufs à Bujumbura a été constatée par rapport à août 2024, principalement due à l'augmentation des prix des matériaux (+7,4 %) et à un bond de 15,7 % des coûts de location du matériel.",
    date: "2024-09-28",
    publicationDate: "2024-10-08"
},
{
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois d'août 2024",
    link: "/documents/ICCLB/ICC-Aout-2024.pdf",
    image: 'assets/indicesICCLB/icclb2024_10m.PNG',
    description: "Une hausse de 6,1 % pour le mois d'août 2024 par rapport à juillet 2024, due à une augmentation des prix des matériaux (+4,1 %) et à une hausse significative de 16,4 % des coûts de main-d'œuvre.",
    date: "2024-08-28",
    publicationDate: "2024-09-06"
},
{
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de juillet 2024",
    link: "/documents/ICCLB/ICC-juillet-2024.pdf",
    image: 'assets/indicesICCLB/icclb2024_10m.PNG',
    description: "Une augmentation de 3,2 % pour le mois de juillet 2024 par rapport à juin 2024, principalement attribuée à l'augmentation des prix des matériaux (+4,2 %).",
    date: "2024-07-28",
    publicationDate: "2024-08-06"
},
{
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de mai 2024",
    link: "/documents/ICCLB/ICC-mai-2024-1.pdf",
    image: 'assets/indicesICCLB/icclb2024_10m.PNG',
    description: "Une  augmentation de 4,6 %  pour le mois de mai 2024 par rapport à avril 2024, résultant d'une hausse des prix des matériaux (+3,6 %), de la main-d'œuvre (+8,1 %) et de la location du matériel (+9,6 %).",
    date: "2024-05-28",
    publicationDate: "2024-06-08"
},
{
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois d'avril 2024",
    link: "/documents/ICCLB/ICC-avril-2024.pdf",
    image: 'assets/indicesICCLB/icclb2024_10m.PNG',
    description: "Une hausse de 0,8 % pour le mois d' avril 2024 par rapport à mars 2024, principalement due à une augmentation des coûts des matériaux (+1,0 %).",
    date: "2024-04-28",
    publicationDate: "2024-05-08"
},
{
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de mars 2024",
    link: "/documents/ICCLB/ICC-mars-2024.pdf",
    image: 'assets/indicesICCLB/icclb2024_10m.PNG',
    description: "Une augmentation de 1,6 %  a été constatée par rapport à février 2024, en grande partie due à l'augmentation de 2,0 % des prix des matériaux et de 2,2 % des coûts de location du matériel.",
    date: "2024-03-28",
    publicationDate: "2024-04-08"
},
{
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de février 2024",
    link: "/documents/ICCLB/ICCLB-fevrier.pdf",
    image: 'assets/indicesICCLB/icclb2024_10m.PNG',
    description: "Une hausse de 3,3 % a été enregistrée par rapport à janvier 2024, en grande partie due à l'augmentation des prix des matériaux de construction (+3,1 %) et à une hausse de 5,0 % des coûts de la main-d'œuvre.",
    date: "2024-02-28",
    publicationDate: "2024-03-11"
},
{
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de janvier 2024",
    link: "/documents/ICCLB/ICC-janv-2024.pdf",
    image: 'assets/indicesICCLB/icclb2024_10m.PNG',
    description: "Une augmentation de 1,6 % par rapport à décembre 2023, à mettre en relation avec une augmentation de 2,1 % des prix des matériaux et une légère hausse de 0,1 % des coûts de location du matériel.",
    date: "2024-01-28",
    publicationDate: "2024-02-09"
},
{
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de décembre 2023",
    link: "/documents/ICCLB/ICC-Mois-decembre-2023-1.pdf",
    image: 'assets/indicesICCLB/icclb2023_12m.PNG',
    description: "Une augmentation de 0,5 % par rapport à novembre 2023, principalement en raison de l'augmentation de 0,5 % des prix des matériaux et d'une hausse de 1,7 % des coûts de location du matériel, poursuivant ainsi la pression inflationniste sur le secteur.",
    date: "2023-12-28",
    publicationDate: "2024-01-09"
},
{
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de novembre 2023",
    link: "/documents/ICCLB/ICC-Mois-nov-2023.pdf",
    image: 'assets/indicesICCLB/icclb2023_12m.PNG',
    description: "Une augmentation de 1,3 % par rapport au mois d'octobre 2023, résultat d'une hausse de 1,3 % des coûts des matériaux et d'une légère augmentation de 1,5 % des charges de main-d'œuvre.",
    date: "2023-11-28",
    publicationDate: "2023-12-07"
},
{
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois d'octobre 2023",
    link: "/documents/ICCLB/ICC-OCT-2023.pdf",
    image: 'assets/indicesICCLB/icclb2023_12m.PNG',
    description: "Une hausse de 1,1 % par rapport à septembre 2023, attribuée à l'augmentation des coûts des matériaux de construction (+1,3 %) et à une hausse de 2,0 % des frais de location de matériel.",
    date: "2023-10-28",
    publicationDate: "2023-11-07"
},
{
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de septembre 2023",
    link: "/documents/ICCLB/ICC-Mois-sept-2023.pdf",
    image: 'assets/indicesICCLB/icclb2023_12m.PNG',
    description: "Une augmentation de 0,6 % par rapport à août 2023, principalement due à une augmentation des prix des matériaux de construction (+0,6 %).",
    date: "2023-09-28",
    publicationDate: "2023-10-09"
},
{
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois d'Août 2023",
    link: "/documents/ICCLB/ICC-Mois-daout-2023.pdf",
    image: 'assets/indicesICCLB/icclb2023_12m.PNG',
    description: "Une légère augmentation de 0,9 % par rapport à juillet 2023, principalement due à l'augmentation des prix des matériaux de construction (+1,0 %) et d'une hausse de 1,3 % liée à la main-d'œuvre.",
    date: "2023-08-28",
    publicationDate: "2023-09-08"
},
{
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de juillet 2023",
    link: "/documents/ICCLB/ICC-Mois-de-juillet-2023.pdf",
    image: 'assets/indicesICCLB/icclb2023_12m.PNG',
    description: "Une hausse de 3,9 % par rapport à juin 2023, attribuable à la hausse des prix des matériaux de construction (+5,2 %).",
    date: "2023-07-28",
    publicationDate: "2023-08-07"
},
{
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de juin 2023",
    link: "/documents/ICCLB/ICC-Mois-de-juin-2023.pdf",
    image: 'assets/indicesICCLB/icclb2023_12m.PNG',
    description: "Une hausse de 1,0 % par rapport au mois de mai 2023, principalement due à l'augmentation des prix des matériaux de construction (+1,2 %).",
    date: "2023-06-28",
    publicationDate: "2023-07-07"
},
{
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de mai 2023",
    link: "/documents/ICCLB/ICC-Mois-de-mai-2023.pdf",
    image: 'assets/indicesICCLB/icclb2023_12m.PNG',
    description: "Une hausse de 0,9 % par rapport au mois d’avril 2023, due à une augmentation des prix des matériaux de construction (+0,8 %) et de la main-d'œuvre (+1,6 %).",
    date: "2023-05-28",
    publicationDate: "2023-06-07"
},
{
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois d'avril 2023",
    link: "/documents/ICCLB/ICC-Mois-de-avril-2023.pdf",
    image: 'assets/indicesICCLB/icclb2023_12m.PNG',
    description: "Une variation en hausse de 1,1 % par rapport au mois de mars 2023, imputable à l'augmentation des prix des matériaux de construction (+1,3 %).",
    date: "2023-04-28",
    publicationDate: "2023-05-08"
},
{
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de mars 2023",
    link: "/documents/ICCLB/ICC-Mois-de-mars-2023.pdf",
    image: 'assets/indicesICCLB/icclb2023_12m.PNG',
    description: "Une hausse de 1,5 % par rapport à février 2023, principalement imputable à l'augmentation des prix des matériaux de construction (+1,6 %).",
    date: "2023-03-28",
    publicationDate: "2023-04-07"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de février 2023",
  link: "/documents/ICCLB/ICC-Mois-de-fevr-2023.pdf",
  image: 'assets/indicesICCLB/icclb2023_12m.PNG',
  description: "Une variation en baisse de 0,5 % par rapport à janvier 2023, principalement due à une baisse des prix des matériaux de construction de 1,2 %.",
  date: "2023-02-28",
  publicationDate: "2023-03-07"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de janvier 2023",
  link: "/documents/ICCLB/ICC-Mois-de-janvier-2023.pdf",
  image: 'assets/indicesICCLB/icclb2023_12m.PNG',
  description: "Une variation en baisse de 0,1 % par rapport à décembre 2022. Cette baisse est due principalement aux prix des matériaux de construction de 0,1 %.",
  date: "2023-01-28",
  publicationDate: "2023-02-07"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de décembre 2022",
  link: "/documents/ICCLB/001-ICCLB-décembre.pdf",
  image: 'assets/indicesICCLB/icclb2022_12m.PNG',
  description: "Une variation en baisse de 0,4 % par rapport à novembre 2022, principalement due à la baisse des prix des matériaux de construction de 0,7 %.",
  date: "2022-12-28",
  publicationDate: "2023-01-06"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de novembre 2022",
  link: "/documents/ICCLB/002-ICCLB-novembre.pdf",
  image: 'assets/indicesICCLB/icclb2022_12m.PNG',
  description: "En novembre 2022, le coût des matériaux de construction des logements neufs à Bujumbura enregistre une variation en baisse de 0,3 % par rapport à octobre 2022, due principalement à la baisse des prix des matériaux de construction de 0,4 %.",
  date: "2022-11-28",
  publicationDate: "2022-12-07"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de septembre 2022",
  link: "/documents/ICCLB/004-ICCLB-septembre.pdf",
  image: 'assets/indicesICCLB/icclb2022_12m.PNG',
  description: "Une hausse de 0,7 % par rapport à août 2022, due principalement à une augmentation des prix des matériaux de construction de 0,9 % et de la location du matériel de 0,3 %.",
  date: "2022-08-28",
  publicationDate: "2022-10-07"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois d'août 2022",
  link: "/documents/ICCLB/005-ICCLB-août.pdf",
  image: 'assets/indicesICCLB/icclb2022_12m.PNG',
  description: "Une hausse de 1,6 % par rapport à juillet 2022, attribuable à l'augmentation des prix des matériaux de construction de 0,9 % et de la main-d'œuvre de 5,0 %.",
  date: "2022-08-28",
  publicationDate: "2022-09-05"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de juillet 2022",
  link: "/documents/ICCLB/006-ICCLB-juillet.pdf",
  image: 'assets/indicesICCLB/icclb2022_12m.PNG',
  description: "Une hausse de 0,2 % par rapport à juin 2022, due principalement à l'augmentation des prix des matériaux de construction de 0,1 % et de la location du matériel de 1,8 %.",
  date: "2022-07-28",
  publicationDate: "2022-08-08"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de juin 2022",
  link: "/documents/ICCLB/007-ICCLB-juin.pdf",
  image: 'assets/indicesICCLB/icclb2022_12m.PNG',
  description: "Une hausse de 0,2 % par rapport à mai 2022, principalement due à l'augmentation des prix des matériaux de construction de 0,3 % et de la location de matériel de 1,2 %.",
  date: "2022-06-28",
  publicationDate: "2022-07-07"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de mai 2022",
  link: "/documents/ICCLB/008-ICCLB-mai.pdf",
  image: 'assets/indicesICCLB/icclb2022_12m.PNG',
  description: "Une hausse de 1,3 % par rapport à avril 2022, due principalement à l'augmentation des prix des matériaux de construction de 1,0 %, de la location du matériel de 1,9 % et d'une hausse significative de la gestion de 18,8 %. ",
  date: "2022-05-28",
  publicationDate: "2022-06-03"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois d'avril 2022",
  link: "/documents/ICCLB/009-ICCLB-avril.pdf",
  image: 'assets/indicesICCLB/icclb2022_12m.PNG',
  description: "Une variation en hausse de 1,0 % par rapport à mars 2022, principalement due à l'augmentation des prix des matériaux de construction de 1,2 %.",
  date: "2022-04-28",
  publicationDate: "2022-05-06"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de mars 2022",
  link: "/documents/ICCLB/0010-ICCLB-mars.pdf",
  image: 'assets/indicesICCLB/icclb2022_12m.PNG',
  description: "Une variation en baisse de 0,5 % par rapport à février 2022, principalement due à la baisse des prix des matériaux de construction de 0,8 %.",
  date: "2022-03-28",
  publicationDate: "2022-04-08"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de février 2022",
  link: "/documents/ICCLB/0011-ICCLB-février.pdf",
  image: 'assets/indicesICCLB/icclb2022_12m.PNG',
  description: "Une hausse de 0,6 % par rapport à janvier 2022, principalement due à une augmentation des prix des matériaux de construction de 0,6 % et de 8,5 % pour les frais de gestion.",
  date: "2022-02-28",
  publicationDate: "2022-03-08"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de janvier 2022",
  link: "/documents/ICCLB/0012-ICCLB-janvier.pdf",
  image: 'assets/indicesICCLB/icclb2022_12m.PNG',
  description: "Une variation en baisse de 0,9 % par rapport à décembre 2021, principalement due à la baisse des prix des matériaux de construction de 1,0 % et des frais de location de matériel de 3,3 %.",
  date: "2022-01-28",
  publicationDate: "2022-02-08"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de décembre 2021",
  link: "/documents/ICCLB/ICCLB-décembre.pdf",
  image: 'assets/indicesICCLB/icclb2021_12m.PNG',
  description: "En décembre 2021, le coût des matériaux de construction des logements neufs à Bujumbura enregistre une variation en baisse de 0,2 % par rapport à novembre 2021, principalement due à la baisse des prix des matériaux de construction de 0,3 %.",
  date: "2021-12-28",
  publicationDate: "2022-01-07"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de novembre 2021",
  link: "/documents/ICCLB/ICCLB-novembre.pdf",
  image: 'assets/indicesICCLB/icclb2021_12m.PNG',
  description: "En novembre 2021, le coût des matériaux de construction des logements neufs à Bujumbura enregistre une variation en hausse de 2,8 % par rapport à octobre 2021, principalement due à la hausse des prix des matériaux de construction de 3,0 % et des frais de location de matériel de 4,7 %.",
  date: "2021-11-28",
  publicationDate: "2021-12-07"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois d'octobre 2021",
  link: "/documents/ICCLB/ICC-Mois-Oct-2021.pdf",
  image: 'assets/indicesICCLB/icclb2021_12m.PNG',
  description: "Une hausse de 0,4 % par rapport à septembre 2021, principalement dû à l'augmentation des prix des matériaux de construction de 0,6 %.",
  date: "2021-10-28",
  publicationDate: "2021-11-08"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de septembre 2021",
  link: "/documents/ICCLB/ICC-Mois-sept-2021.pdf",
  image: 'assets/indicesICCLB/icclb2021_12m.PNG',
  description: "Une hausse de 1,3 % par rapport à août 2021, principalement due à une augmentation des prix des matériaux de construction de 1,7 %.",
  date: "2021-09-28",
  publicationDate: "2021-10-05"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois d'août 2021",
  link: "/documents/ICCLB/ICC-Mois-aout-2021.pdf",
  image: 'assets/indicesICCLB/icclb2021_12m.PNG',
  description: "Une variation en hausse de 1,0 % par rapport à juillet 2021. Cette hausse est essentiellement due à l'augmentation des prix des matériaux de construction de 1,0 % et de la main d’œuvre de 1,1 %.",
  date: "2021-08-28",
  publicationDate: "2021-09-07"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de juin 2021",
  link: "/documents/ICCLB/ICC-Mois-juin-2021.pdf",
  image: 'assets/indicesICCLB/icclb2021_12m.PNG',
  description: "Une hausse de 1,4 % par rapport à mai 2021, principalement due à l'augmentation des prix des matériaux de construction de 2,0 %.",
  date: "2021-06-28",
  publicationDate: "2021-07-07"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de mai 2021",
  link: "/documents/ICCLB/ICC-Mois-mai-2021.pdf",
  image: 'assets/indicesICCLB/icclb2021_12m.PNG',
  description: "Une hausse de 3,8 % par rapport à avril 2021, due essentiellement à une augmentation de la main d’œuvre de 16 %.",
  date: "2021-05-28",
  publicationDate: "2021-06-04"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois d'avril 2021",
  link: "/documents/ICCLB/ICC-Mois-avril-2021.pdf",
  image: 'assets/indicesICCLB/icclb2021_12m.PNG',
  description: "Une hausse de 2,6 % par rapport à mars 2021, provenant principalement de la hausse des prix des matériaux de construction de 3,4 %.",
  date: "2021-04-28",
  publicationDate: "2021-05-07"
},
{
  title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB) du mois de février 2021",
  link: "/documents/ICCLB/ICC-Mois-fevrier-2021.pdf",
  image: 'assets/indicesICCLB/icclb2021_12m.PNG',
  description: "Une hausse de 3,0 % par rapport à janvier 2021, due principalement à l'augmentation des prix des matériaux de construction de 2,8 %, de la main-d'œuvre de 3,4 % et de la location du matériel de 4,8 %.",
  date: "2021-02-28",
  publicationDate: "2021-03-10"
}
];
function IndiceCoutConstruction() {
  const navigate = useNavigate(); 
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredICCLB, setFilteredICCLB] = useState(icclbData);
 

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    if (year === 'Tous') {
      setFilteredICCLB(icclbData);
    } else {
      const filtered = icclbData.filter((indice) => {
        const indiceYear = new Date(indice.date).getFullYear();
        return indiceYear === parseInt(year);
      });
      setFilteredICCLB(filtered);
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: { main: '#388E3C' },
      secondary: { main: '#673AB7' },
      background: { default: '#f5f5f5' },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h6: { fontWeight: '500', fontSize: '1rem', textTransform: 'none', color: '#3B3F54' },
      body2: { fontSize: 14, letterSpacing: 0.25, color: '#6B778C' },
      body1: { fontSize: 16, letterSpacing: 0.5, color: '#6B778C' },
    },
    components: {
      MuiCard: {
        styleOverrides: {
          root: {
            transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
            '&:hover': {
              transform: 'scale(1.05)',
              boxShadow: '0px 12px 20px rgba(0, 0, 0, 0.15)',
            },
            borderRadius: '8px',
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          h6: { fontWeight: '500', fontSize: '1rem' },
          h4: { fontWeight: '600' },
        },
      },
      MuiFormControl: {
        styleOverrides: {
          root: {
            marginBottom: '16px',
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
         <br />
        <br />
        <Container maxWidth="lg" style={{ paddingTop: '24px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
            Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB)
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            L’Institut National de la Statistique (INSBU) met à la disposition des utilisateurs l’Indice du Coût de Construction (ICCLB base 100 Février 2018). Cet indice composite, basé sur l’observation des prix des matériaux de construction, du coût de la main-d’œuvre, des moyens de gestion et de location du matériel de construction, vient combler l’absence d’indicateurs permettant de suivre la variation des prix dans le secteur du Bâtiment et des Travaux Publics (BTP).
          </Typography>
             <FormControl fullWidth variant="outlined" style={{ width: '300px' }}>
      <InputLabel id="year-select-label">Sélectionner par l'année de réalisation</InputLabel>
      <StyledSelect
        labelId="year-select-label"
        id="year-select"
        value={selectedYear}
        onChange={handleYearChange}
        label="Sélectionner par l'année de réalisation"
      >
        <MenuItem value="Tous">Tous les indices</MenuItem>
        {[...new Set(icclbData.map((indice) => new Date(indice.date).getFullYear()))]
          .sort((a, b) => b - a) 
          .map((year) => (
            <MenuItem key={year} value={year.toString()}>
              {year}
            </MenuItem>
          ))}
      </StyledSelect>
    </FormControl>
          <Grid container spacing={1} style={{ marginTop: '5px' }}>
            {filteredICCLB.slice(0, visibleCount).map((indice, index) => (
              <Grid item xs={12} sm={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a
                      href={indice.link}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <CardMedia
                        component="img"
                        sx={{ width: 61, height: 120, m: 2 }}
                        image={indice.image}
                        alt={indice.title}
                      />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                        <a
                          href={indice.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                          {<DownloadIcon />}{indice.title}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {indice.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(indice.publicationDate).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredICCLB.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                marginBottom: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus d'Indices
            </Button>
          )}

          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px', lineHeight: 1.6 }}>
            <strong>Note :</strong> Les indices du Coût de Construction de Logements Neufs (ICCLB) sont publiés le <strong>15 de chaque mois</strong>, soit 15 jours après la fin du mois précédent. Les dates de publication des indices pour les mois à venir sont les suivantes :
            <ul style={{ listStyleType: 'circle', margin: '10px 0 10px 20px', padding: 0 }}>
              <li><strong>15 janvier</strong> - Publication des indices du mois de décembre</li>
              <li><strong>15 février</strong> - Publication des indices du mois de janvier</li>
              <li><strong>15 mars</strong> - Publication des indices du mois de février</li>
              <li><strong>15 avril</strong> - Publication des indices du mois de mars</li>
              <li><strong>15 mai</strong> - Publication des indices du mois d'avril</li>
              <li><strong>15 juin</strong> - Publication des indices du mois de mai</li>
              <li><strong>15 juillet</strong> - Publication des indices du mois de juin</li>
              <li><strong>15 août</strong> - Publication des indices du mois de juillet</li>
              <li><strong>15 septembre</strong> - Publication des indices du mois d'août</li>
              <li><strong>15 octobre</strong> - Publication des indices du mois de septembre</li>
              <li><strong>15 novembre</strong> - Publication des indices du mois d'octobre</li>
              <li><strong>15 décembre</strong> - Publication des indices du mois de novembre</li>
            </ul>
          </Typography>

          <Box display="flex" justifyContent="flex-start" alignItems="center">
            <Button
              onClick={() => navigate('/indice')}
              style={{
                marginTop: '5px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              <ArrowBackIcon style={{ marginRight: '8px' }} />
              Retour à la page des indices
            </Button>
          </Box>
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default IndiceCoutConstruction;